// extracted by mini-css-extract-plugin
export default {"withTopBorder":"uRLjKCBQ2qBRD7Q5ODPT","section":"qjSeC31ZXd1HjGnFbZJd"};